import { runTransactionWithRetry } from '@wix/wix-data-client-common/dist/esm/business-logic/editor-sdk/runTransactionWithRetry'
import { COLUMN_ROLE, STRIP_ROLE } from '@wix/wix-data-client-common-standalone'

export default async ({
  editorSdkProxy,
  sourceConnections,
  targetConnections,
  source,
  target,
  targetIsStrip,
}) => {
  const backgroundConnection = sourceConnections.find(
    ({ role }) => role === COLUMN_ROLE,
  )
  if (!backgroundConnection) {
    return
  }
  const shouldAddStripRoleConnection =
    targetIsStrip &&
    targetConnections.every(
      ({ role, isPrimary }) => role !== STRIP_ROLE && !isPrimary,
    )
  await runTransactionWithRetry(editorSdkProxy, async () => {
    await editorSdkProxy.controllers.disconnect({
      controllerRef: backgroundConnection.controllerRef,
      connectToRef: source,
      role: COLUMN_ROLE,
    })
    await editorSdkProxy.controllers.connect({
      controllerRef: backgroundConnection.controllerRef,
      connectToRef: target,
      role: COLUMN_ROLE,
      connectionConfig: backgroundConnection.config,
    })
    if (shouldAddStripRoleConnection) {
      await editorSdkProxy.controllers.connect({
        controllerRef: backgroundConnection.controllerRef,
        connectToRef: target,
        role: STRIP_ROLE,
        isPrimary: true,
      })
    }
  })
}
